import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/classess.scss";
import "./styles/common.scss";
import "./styles/fonts.scss";
import "./styles/toast.css"
import "./language"
import App from "./App";
import { BrowserRouter } from "react-router-dom";


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
